import React from 'react';

const BrandHeader = ({ brandObj, brandName }) => {
    // Check if a brand banner exists in the metaData
    const hasBanner = brandObj?.metaData?.brand_banner;

    return (
        <div className="brand__header">
            {hasBanner ? (
                <img
                    decoding="async"
                    alt=""
                    src={brandObj.metaData.brand_banner}
                    className="brand__header-image"
                />
            ) : (
                <h2>{brandName}</h2>
            )}
        </div>
    );
};

export default BrandHeader;
